import React from "react"
import Skeleton from 'react-loading-skeleton';

const TableSkeleton = _ => (
    <div className="py-5">
      <div style={{textAlign: "right", padding: "1rem 2rem 1rem 1rem"}}>
        <Skeleton height={15} width="20%" />
      </div>
      <div style={{textAlign: "center"}}>
        <Skeleton height={15} width="12%" count={42} style={{margin: "0.8rem 0.5rem"}} />
      </div>
      <div style={{textAlign: "center", marginTop: "2rem"}}>
        <Skeleton height={8} width="5%" count={14} style={{margin: "0.5rem"}} />
      </div>
    </div>
)


export default TableSkeleton

